import * as CONSTANT from "constants/text"
import AxiosConfig from "axiosConfig"


/*
* Method to POST a new friend request.
* only required parameter is the username of the friend.
*/
export const invite = function (username){
    let form_data = new FormData();
    form_data.append("username", username);
    AxiosConfig.post("friends/requests/", form_data)
    .then(response=>{
        //route to the cancel page.
        window.location.assign(
            `/profile/${CONSTANT.REVIEW}/${response.data.id}/${username}/`
        )
    });
}


/*
* Method for setting a friend request to "ACCEPTED"
* or for updating a friend request in the "PENDING_REQUESTEE" or "PENDING_REQUESTER" status
* to the "PENDING" status when the parent is approving a request.
* Required parameters are current friendRequestId and type
* Routes user back to the ManageChildTribe page or Tribe page depending on type parameter
*/
export const accept = function (friendRequestID, type) {
    let form_data = new FormData();
    if (type === CONSTANT.GUARDIAN_REVIEW) {
        form_data.append("status", "PENDING");
        AxiosConfig.patch("friends/requests/" + friendRequestID + "/", form_data);
        setTimeout(() => window.location.assign("/manage-child-tribe"), 40);
    } else if (type === CONSTANT.RECEIVED) {
        form_data.append("status", "ACCEPTED");
        AxiosConfig.patch("friends/requests/" + friendRequestID + "/", form_data);
        setTimeout(() => window.location.assign("/friends"), 40);
    }
}


/*
* Method for updating a friend request to the "REJECTED" status.
* Required parameters are current friendRequestId and type
* Routes user back to the ManageChildTribe page or Tribe page depending on type parameter
*/
export const decline = function (friendRequestID, type) {
    let form_data = new FormData();
    form_data.append("status", "REJECTED");
    AxiosConfig.patch("friends/requests/" + friendRequestID + "/", form_data);
    //Code to prevent a redirect right after patching the request
    //I don't know of a better way to do this
    if (type === CONSTANT.GUARDIAN_REVIEW) {
        setTimeout(() => window.location.assign("/manage-child-tribe"), 40);
    } else if (type === CONSTANT.REVIEW || type === CONSTANT.RECEIVED) {
        setTimeout(() => window.location.assign("/friends"), 40);
    }
}


/*
* Method for updating a friend request to the "BLOCKED" status.
* Required parameters are username and type.
* Routes user back to the ManageChildTribe page or Tribe page depending on type parameter
*/
export const block = function (username, type) {
    AxiosConfig.post("friends/block/" + username + "/");
    if (type === CONSTANT.GUARDIAN_REVIEW){
        setTimeout(() => window.location.assign("/manage-child-tribe"), 40);
    }
    else {
        setTimeout(() => window.location.assign("/friends"), 40);
    }
}


/*
* Method for unblocking a friend request
* Required parameter is the FriendRequestID
* Routes user back to the blocked users page.
*/
export const unblock = function (friendRequestID) {
    let form_data = new FormData();
    form_data.append("request_id", friendRequestID);
    AxiosConfig.delete("friends/" + friendRequestID +"/unblock", form_data);
    setTimeout(() => window.location.assign("/blocked-users"), 40);
}

